import classNames from 'classnames'
import { map, range } from 'lodash-es'

export default function OpenHomeLayout({
  title,
  subTitle,
  children,
  border = false
}) {
  return (
    <div>
      <div className='text-black text-xl'>{title}</div>
      {subTitle && <div className='text-black text-lg mt-10'>{subTitle}</div>}
      <div className={classNames('mt-8', { 'border rounded-sm': border })}>
        {children}
      </div>
    </div>
  )
}

export function EnquiryRow({
  children,
  text,
  button,
  href = ''
}) {

  const Tag = href ? 'a' : 'label'
  return (
    <Tag href={href} target={href ? '_blank' : ''} className='cursor-pointer h-46 border rounded-sm flex items-center justify-between pl-10 pr-6 sm:pl-20 mt-8 sm:mt-12 first:mt-0 hover:border-primary'>
      {children}
      <span className='text-primary text-md sm:text-base'>{text}</span>
      {button}
    </Tag>
  )
}

export function OpenHomeRow({
  children,
  text,
  button
}) {

  return (
    <div className='h-42 border-t first:border-t-0 flex items-center px-12 text-sm even:bg-neutral-1'>
      {children}
      <span className='text-black'>{text}</span>
      {button}
    </div>
  )
}


export function SkeletonCard() {
  return (
    <div className='skeleton-wrap'>
      <span className='h-14 w-1/3'></span>
      <div className='mt-10 space-y-4'>
        {
          map(range(0, 3), idx => (
            <span className='h-20' key={idx}></span>
          ))
        }
      </div>
    </div>
  )
}